/* @flow */
import apiRequest from 'lib/apiRequest';
import User from 'entities/User';
import Entity from 'lib/Entity';
import { DEFAULT_COLOR } from 'entities/Group';

import schoolImage from 'assets/images/school-circle.svg';
import districtImage from 'assets/images/admin/district.svg';

export default class Organization extends Entity {
  initialize() {
    this.urlRoot = '/organizations';
  }

  defaults() {
    return {
      admins: [],
    };
  }

  getName() {
    return this.get('name');
  }

  getType() {
    return this.get('type') || 'School';
  }

  getCity() {
    return this.get('city');
  }

  getState() {
    return this.get('state');
  }

  getFormattedAddress() {
    return [this.getCity(), this.getState()].filter(value => value).join(', ');
  }

  getMemberSampleString() {
    return this.get('members_sample_string');
  }

  getMemberCount() {
    return this.get('members_count');
  }

  getAdmins() {
    return this.get('admins');
  }

  getLatitude() {
    return this.get('latitude');
  }

  getLongitude() {
    return this.get('longitude');
  }

  getNCESId() {
    return this.get('nces_id');
  }

  getAccentColor() {
    return DEFAULT_COLOR;
  }

  getStatistics() {
    return this.get('org_stats');
  }

  getAvatarUrl() {
    const type = this.get('type');

    if (type === 'School') {
      return schoolImage;
    } else if (type === 'District') {
      return districtImage;
    }

    throw new Error('Unsupported organization type ' + type);
  }

  hasAdmins() {
    return this.getAdmins().length > 0;
  }

  isAdminBy(user: User) {
    return this.getAdmins().some(admin => admin.id === user.id);
  }

  create() {
    return apiRequest('/organizations', 'POST', {
      organization: {
        name: this.getName(),
        city: this.getCity(),
        state: this.getState(),
        type: this.getType(),
      },
    }).then(org => Organization.fromJSON(org));
  }
}



// WEBPACK FOOTER //
// ./src/entities/Organization.js